var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThickCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9696DD05-E115-4651-9543-D00DE28C7B40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donor-Portal-Access---Search-CRM-User",
    transform: "translate(-1289.000000, -855.000000)",
    stroke: "#48D2A0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(960.601608, 845.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toggle-/-Round-Yes-Copy-2",
    transform: "translate(311.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-thick-check",
    transform: "translate(19.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.142613014,3.12093294 L3.9576,7.88966667",
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0 L4,8",
    id: "Stroke-25"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThickCheck);
export default __webpack_public_path__ + "static/media/Icon _ thick-check.c239af2f9aa438e01f6278df1aafc6e9.svg";
export { ForwardRef as ReactComponent };